export enum PsPartnersEnum {
  RCFD = 'Regional Clinical Director',
  CFD = 'Market Clinical Manager',
  CFM = 'Clinical Excellence Captain',
  PSA = 'Professional Services Analyst',
  FMM = 'Field Marketing Manager',
}
